// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProjectSettingsControlEmployee_wrapper__2fpf8","title":"ProjectSettingsControlEmployee_title__1i2mQ","empty":"ProjectSettingsControlEmployee_empty__MtA7f"};